import React from 'react';
import PreConfigV from './preConfigv';

const PreConfig = () => {
  return (
    <div>
      <PreConfigV />
    </div>
  );
};

export default PreConfig;